export default __webpack_public_path__ + "static/media/sleeping-owl.5cb42d07.png";